import { createContext, ReactNode, useContext, useState } from 'react'
import { MissionTriggerModel } from '../../domain/model/mission-trigger.model'
import MissionTrigger from '../components/triggers'

type ContextProps = {
  missionTrigger: MissionTriggerModel;
  isOpen: boolean;
  action: IAction;
  handleUpdateAction: (action: IAction) => void;
  handleToggleMissionTrigger: (mission: MissionTriggerModel) => void;
  handleToggleTriggerVisibility: (state: boolean) => void;
}

type MissionTriggerProviderProps = {
  children: ReactNode;
}

type IAction = {
  action: () => void;
}

const MissionTriggerContext = createContext({} as ContextProps)

const MissionTriggerProvider = ({ children }: MissionTriggerProviderProps) => {
  const [missionTrigger, setMissionTrigger] = useState<MissionTriggerModel>({} as MissionTriggerModel)
  const [isOpen, setIsOpen] = useState(false)
  const [action, setAction] = useState<IAction>({} as IAction)

  function handleToggleMissionTrigger (missionTrigger: MissionTriggerModel) {
    setMissionTrigger(missionTrigger)
  }

  function handleToggleTriggerVisibility (state: boolean) {
    setIsOpen(state)
  }

  function handleUpdateAction (action: IAction) {
    setAction(action)
  }

  return (
    <MissionTriggerContext.Provider value={{
      missionTrigger,
      isOpen,
      action,
      handleToggleMissionTrigger,
      handleToggleTriggerVisibility,
      handleUpdateAction
    }}>
      { children }
      <MissionTrigger missionTrigger={missionTrigger} isShowing={isOpen} action={action}/>
    </MissionTriggerContext.Provider>
  )
}

const useMissionTrigger = () => {
  const context = useContext(MissionTriggerContext)

  if (!context) throw new Error('useMissionTrigger must be used within a provider MissionTriggerProvider')

  return { ...context }
}

export { MissionTriggerContext, useMissionTrigger, MissionTriggerProvider }
